import { faDollarSign, faSearch } from "@fortawesome/free-solid-svg-icons";
import React, { Fragment, useCallback, useEffect, useState, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router";
import { Toast } from "./../UI/toast/Toast";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { checkUserToken } from "../../helpers/api/auth";
import { fetchCondominiumBanks } from "../../helpers/api/banks";
import {
  fetchDebtsToPayAsPropertyCuenta,
  fetchMyAliquotsAsProperty,
  findOneDebtToPayAsPropertyDetails,
  markAsPaidDebtToPayAsProperty,
} from "../../helpers/api/finance";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import WizardError from "../auth/register/WizardError";
import FileUploadArea from "../common/FileUploadArea";
import ButtonIcon from "../common/ButtonIcon";
import Loader from "../common/Loader";
import PageHeader from "../common/PageHeader";
import FullPagination from "../common/pagination/FullPagination";
import SelectBankListItem from "../common/SelectBankListItem";
import { PreloadState } from "./../UI/preloading/PreloadState";

import { CurrencyContext } from "../../context/Context";

const CreatePropertyPayment = ({ setRedirect, setRedirectUrl }) => {
  const { id } = useParams([]);

  const {
    state: { amount, date, aliquot, total_paid },
  } = useLocation();

  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const { token } = useSelector((state) => state.auth.user);
  // eslint-disable-next-line
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bank, setBank] = useState(null);
  const [fund, setFund] = useState([]);
  const [aliquots, setAliquots] = useState(null);
  const [debttopay, setDebttopay] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [totalProperties, setTotalProperties] = useState(0);
  const [total, setTotal] = useState(amount - total_paid);
  const [idCuenta, setIdCuenta] = useState([]);
  const [file, setFile] = useState(null);
  const [cash, setCash] = useState(false);
  const [current, setCurrent] = useState(false);
  /*   const [selectedCuentaId, setSelectedCuentaId] = useState([]); */
  const [params, setParams] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });
  const [search, setSearch] = useState("");
  const {
    data,
    handler: { goToPage, nextPage, perPage, previousPage },
    isLoading,
    meta,
  } = useSWRFetchPagination(fetchCondominiumBanks, params);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    setValue,
    setError,
    control,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const [isPending, setIsPending] = useState(false);

  register("bank_id");
  register("voucher");
  register("reference");

  const activeExchangeRate = Number(curr?.value ?? 0);

  const save = async (values) => {
    setIsPending(true);
    if (cash === false) {
      const { bank_id, voucher, reference, payment_by_account } = values;
      try {
        let formData = new FormData();

        formData.append("amount", total);
        if (activeExchangeRate) formData.append("rate", activeExchangeRate);
        /*       formData.append("payment_by_account", 1); */
        formData.append("payment_by_account", payment_by_account);
        if (payment_by_account !== 1) {
          formData.append("bank_id", bank_id);
          formData.append("reference", reference);
          if (file) formData.append("voucher", file);
          /*   if (voucher) formData.append("voucher", voucher); */
        }
        formData.append(`propertyDebtsToPay[0]`, id);
        console.log("yujuu", payment_by_account);

        const { code } = await markAsPaidDebtToPayAsProperty(formData);
        if (code === SUCCESS_RESPONSE.CREATED) {
          collapseOneOpen(false);
          setRedirectUrl(`/dashboard/my/finance/topay`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago emitido exitosamente, espere su aprobación.`,
          });
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      }
    }

    if (current === true) {
      const { bank_id, voucher, reference, payment_by_account } = values;
      try {
        let formData = new FormData();

        formData.append("amount", total);
        if (activeExchangeRate) formData.append("rate", activeExchangeRate);
        /*       formData.append("payment_by_account", 1); */
        formData.append("payment_by_account", payment_by_account);
        if (payment_by_account != 1) {
          formData.append("bank_id", bank_id);
          formData.append("reference", reference);
          /*     const imageUrl = `${selectedCondominium}/${property.user.username}/paymentProperty/${file.name}`;
          const url = `https://homelan.nyc3.digitaloceanspaces.com/${imageUrl}`;
          if (file) formData.append("voucher", url); */
          /*   if (voucher) formData.append("voucher", voucher); */
        }
        formData.append(`propertyDebtsToPay[0]`, id);
        console.log("yujuu", payment_by_account);

        const { code } = await markAsPaidDebtToPayAsProperty(formData);
        if (code === SUCCESS_RESPONSE.CREATED) {
          collapseOneOpen(false);
          setRedirectUrl(`/dashboard/my/finance/topay`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago emitido exitosamente, espere su aprobación.`,
          });
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      }
    }

    if (cash === true) {
      const { bank_id, voucher, reference, payment_by_account } = values;
      try {
        let formData = new FormData();

        formData.append("amount", total);
        if (activeExchangeRate) formData.append("rate", activeExchangeRate);
        /*       formData.append("payment_by_account", 1); */
        formData.append("payment_by_account", 2);
        if (payment_by_account !== 1) {
          /*    formData.append("bank_id", bank_id);
          formData.append("reference", reference); */
          if (file) formData.append("voucher", file);
          /*   if (voucher) formData.append("voucher", voucher); */
        }
        formData.append(`propertyDebtsToPay[0]`, id);
        console.log("yujuu", payment_by_account);

        const { code } = await markAsPaidDebtToPayAsProperty(formData);
        if (code === SUCCESS_RESPONSE.CREATED) {
          collapseOneOpen(false);
          setRedirectUrl(`/dashboard/my/finance/topay`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago emitido exitosamente, espere su aprobación.`,
          });
        }
      } catch (error) {
        handleErrorMessage(error);
        console.log(error);
      }
    }
    setIsPending(false);
  };

  /* const save = async (values) => {
    const { bank_id, voucher, reference, payment_by_account } = values;
    collapseOneOpen(false);
    try {
      let formData = new FormData();

      formData.append("amount", total);
      formData.append("payment_by_account", payment_by_account);
      if (payment_by_account != 1) {
        formData.append("bank_id", bank_id);
        formData.append("reference", reference);
        if (voucher) formData.append("voucher", voucher);
      }
      formData.append(`propertyDebtsToPay[0]`, id);

      console.log(idCuenta);

      console.log("yujuu", payment_by_account);

      const { code } = await markAsPaidDebtToPayAsProperty(formData);

      if (code === SUCCESS_RESPONSE.CREATED) {
        setRedirectUrl(`/dashboard/my/finance/topay/`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago emitido exitosamente, espere su aprobación.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  }; */


  useEffect(() => {
    if (selectedBankId) {
      clearErrors("bank_id");
    } else {
      setError("bank_id", {
        message: "El banco es requerido",
      });
    }
    // eslint-disable-next-line
  }, [selectedBankId]);

  const [cuentas, setCuentas] = useState([]);
  const fetchApiCuentas = useCallback(async () => {
    try {
      const response = await fetchDebtsToPayAsPropertyCuenta(params);
      setCuentas(
        response.data && response.data.length >= 0 ? response.data : []
      );
      console.log("cuentas", response.data);
    } catch (error) {
      setCuentas([]);
    }
  }, []);

  useEffect(() => {
    fetchApiCuentas();
  }, [fetchApiCuentas]);

  useEffect(() => {
    if (date) {
      const findOne = async () => {
        try {
          const response = await checkUserToken(token);
          const { data } = await findOneDebtToPayAsPropertyDetails(date);
          setDebttopay(data);
          setUser(response);
          if (aliquot) {
            const rep = await fetchMyAliquotsAsProperty();
            setAliquots(rep.data);
            if (rep.data) {
              setIdCuenta(rep.data.id);
              setTotal(amount - rep.data.value);
            }
          }
          let totala = 0;
          data.forEach((val) => {
            totala += val.price;
          });
          setTotalProperties(totala / total);
        } catch (error) {
          handleErrorMessage(error);
        } finally {
          setLoading(false);
        }
      };
      findOne();
    }
    // eslint-disable-next-line
  }, []);

  const filteredDebts = cuentas.filter((debt) => debt.id === Number(id));
  console.log(filteredDebts);
  console.log(debttopay);
  console.log(id);

  const renderBanksItems = () => {
    return data.map((bank, i) => {
      return (
        <SelectBankListItem
          key={i}
          // `condominium_banks_id` (la cuenta de este banco EN este
          // condominio), no `bank.bank_id` (el banco generico, compartido
          // entre condominios) -- bill_to_pays.bank_id referencia
          // condominium_banks.id, asi que mandar bank.bank_id acreditaba el
          // pago al banco de OTRO condominio. Mismo criterio que PropertyToPays.
          id={bank.condominium_banks_id}
          selected={selectedBankId}
          onSelect={() => {
            setBank(bank);
            setSelectedBankId(bank.condominium_banks_id);
            setValue("bank_id", bank.condominium_banks_id);
          }}
          title={bank.name}
          alternativeName="banco"
          createdAt={bank.created_at}
          owner_dni={bank.owner_dni}
          owner_name={bank.owner_name}
          account={bank.account_number}
        />
      );
    });
  };

  return (
    <Fragment>
      <PageHeader
        title="Emisión de pago"
        titleTag="h2"
        description={"Registra tu pago de la cuenta por pagar."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        <Button
          data-testid="condominium-button-chat"
          color="link"
          size="sm"
          className="pl-0"
          to="#!"
        >
          Tienes alguna pregunta? chatea con nosotros
        </Button>
      </PageHeader>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-transparent shadow-none"
        onSubmit={handleSubmit(save)}
      >
        <PreloadState
          loading={isPending}
          message={"Emitiendo pago por favor espere..."}
        >
          <>
            <Row className="no-gutters">
              {!loading ? (
                <>
                  <Col className="pr-lg-2 mb-3" lg={8}>
                    <Card>
                      <CardBody className="bg-light">
                        <Row>
                          <Col>
                            <h5 className="mb-2 mb-md-0">Detalle de pago</h5>
                          </Col>
                          <Col>
                            <Row>
                              <Col sm tag={FormGroup}>
                                <Label for="acronym">Origen de fondos</Label>
                                <Controller
                                  name="payment_by_account"
                                  control={control}
                                  defaultValue="Selecciona"
                                  rules={{
                                    required: {
                                      value: true,
                                      message: "Seleccione un fondo",
                                    },
                                    /*  validate: (value) => {
                                      if (
                                        amount > balance.data &&
                                        current === true
                                      ) {
                                        return "";
                                      }
                                      return true;
                                    }, */
                                  }}
                                  render={({ onChange, name, value }) => (
                                    <Input
                                      type="select"
                                      name="payment_by_account"
                                      id="payment_by_account"
                                      className={`${errors["payment_by_account"]?.message
                                          ? "border-danger"
                                          : ""
                                        } form-select, overflow-auto`}
                                      onChange={(event) => {
                                        setFund(event.target.value === "2");
                                        setCurrent(event.target.value === "1");
                                        setCash(event.target.value === "3");
                                        setValue(
                                          "payment_by_account",
                                          event.target.value
                                        );
                                        onChange(`${event.target.value}`);
                                      }}
                                    /*    onChange={handleInputChange}
                               innerRef={register({
                                 required: { value: true, message: "Ingresar el monto" },
                               })} */
                                    >
                                      <option
                                        selected
                                        value="Selecciona"
                                        disabled
                                      >
                                        ---
                                      </option>
                                      <option value="1">Caja</option>
                                      <option value="2">Transferencia</option>
                                      <option value="3">Efectivo</option>
                                    </Input>
                                  )}
                                />
                                <WizardError
                                  error={errors["payment_by_account"]?.message}
                                  className="fs--1 font-weight-normal d-block"
                                />
                              </Col>
                            </Row>
                            {fund === true && (
                              <Row>
                                <Col tag={FormGroup}>
                                  <Label>
                                    Seleccione un banco del condominio
                                  </Label>
                                  <Row>
                                    <Col
                                      tag={FormGroup}
                                      xs={9}
                                      className="pr-0"
                                    >
                                      <Input
                                        type="text"
                                        placeholder="Ingrese el nombre de un banco"
                                        onChange={(event) =>
                                          setSearch(event.target.value)
                                        }
                                      />
                                    </Col>
                                    <Col tag={FormGroup} xs={3}>
                                      <ButtonIcon
                                        className="btn-block"
                                        style={{ whiteSpace: "nowrap" }}
                                        icon={faSearch}
                                        color="falcon-default"
                                        onClick={() =>
                                          setParams((prev) => {
                                            return { ...prev, search };
                                          })
                                        }
                                      >
                                        Buscar
                                      </ButtonIcon>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      {!isLoading ? (
                                        data.length >= 1 ? (
                                          renderBanksItems()
                                        ) : (
                                          <p>No se han encontrado bancos.</p>
                                        )
                                      ) : (
                                        <Loader padding="py-3" />
                                      )}
                                      <FullPagination
                                        nextPage={nextPage}
                                        prevPage={previousPage}
                                        goToPage={goToPage}
                                        meta={meta}
                                        className={"shadow-none"}
                                        posText={"bancos"}
                                        perPage={perPage}
                                      />
                                      <WizardError
                                        error={errors["bank_id"]?.message}
                                        className="fs--1 font-weight-normal d-block"
                                      />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            )}
                            {fund === true && (
                              <FormGroup>
                                <Label for="name">Nombre del banco</Label>
                                <Input
                                  disabled
                                  defaultValue={bank?.name || undefined}
                                  autoComplete="off"
                                  name="name"
                                  id="title"
                                  placeholder="Nombre del banco"
                                />
                              </FormGroup>
                            )}
                            {fund === true && (
                              <Row form>
                                <Col sm tag={FormGroup}>
                                  <Label for="account_number">
                                    Número de cuenta
                                  </Label>
                                  <NumberFormat
                                    disabled
                                    value={bank?.account_number || undefined}
                                    format="#### #### #### #### #### #### ####"
                                    placeholder="Número de cuenta"
                                    className="form-control"
                                    renderText={(value, props) => (
                                      <div {...props}>{value}</div>
                                    )}
                                  />
                                </Col>
                                <Col sm tag={FormGroup}>
                                  <Label for="owner_name">
                                    Nombre del propietario
                                  </Label>
                                  <Input
                                    disabled
                                    defaultValue={bank?.owner_name || undefined}
                                    autoComplete="off"
                                    name="owner_name"
                                    id="owner_name"
                                    placeholder="Nombre del propietario"
                                  />
                                </Col>
                              </Row>
                            )}
                            {fund === true && (
                              <Row form>
                                <Col sm tag={FormGroup}>
                                  <Label for="owner_dni">
                                    Identificación (DNI)
                                  </Label>
                                  <Input
                                    defaultValue={bank?.owner_dni || undefined}
                                    id="owner_dni"
                                    name="owner_dni"
                                    disabled
                                    type="text"
                                    placeholder="Identificación"
                                  />
                                </Col>
                              </Row>
                            )}
                            {fund === true && (
                              <Row>
                                <Col tag={FormGroup}>
                                  <FileUploadArea
                                    label="Comprobante de pago"
                                    accept="image/*,application/pdf"
                                    onChange={(e) => {
                                      const f = e.target.files[0];
                                      if (f) {
                                        setFile(f);
                                        setImagePreview(URL.createObjectURL(f));
                                      }
                                    }}
                                    preview={imagePreview}
                                    fileName={file?.name}
                                    onRemove={() => {
                                      setFile(null);
                                      setImagePreview(null);
                                    }}
                                    error={errors["voucher"]?.message}
                                  />
                                </Col>
                              </Row>
                            )}
                            {cash === true && (
                              <Row>
                                <Col tag={FormGroup}>
                                  <FileUploadArea
                                    label="Comprobante de pago"
                                    accept="image/*,application/pdf"
                                    onChange={(e) => {
                                      const f = e.target.files[0];
                                      if (f) {
                                        setFile(f);
                                        setImagePreview(URL.createObjectURL(f));
                                      }
                                    }}
                                    preview={imagePreview}
                                    fileName={file?.name}
                                    onRemove={() => {
                                      setFile(null);
                                      setImagePreview(null);
                                    }}
                                    error={errors["voucher"]?.message}
                                  />
                                </Col>
                              </Row>
                            )}
                            {fund === true && (
                              <Row>
                                <Col tag={FormGroup}>
                                  <Label>Código de referencia</Label>
                                  <Input
                                    type="text"
                                    name="reference"
                                    id="reference"
                                    onChange={(e) =>
                                      setValue("reference", e.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                            )}
                            {cash === true && (
                              <Row>
                                <Col tag={FormGroup}>
                                  <Label>Código de referencia</Label>
                                  <Input
                                    type="text"
                                    name="reference"
                                    id="reference"
                                    onChange={(e) =>
                                      setValue("reference", e.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col className="pl-lg-2 mb-3" lg={4}>
                    <Card>
                      <CardHeader>
                        <Row>
                          <Col>
                            <h5 className="mb-2 mb-md-0">Conceptos</h5>
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody className="bg-light">
                        <Table className="m-0 p-0">
                          <thead>
                            <tr>
                              <th>Concepto</th>
                              <th>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cuentas.map(
                              (cuenta, i) =>
                                cuenta.id === Number(id) && (
                                  <tr key={i}>
                                    <td>
                                      {cuenta.finance !== null
                                        ? cuenta.finance.name
                                        : cuenta.reserve_fund.name}
                                    </td>
                                    <td>
                                      <NumberFormat
                                        className="text-nowrap"
                                        thousandSeparator={true}
                                        prefix={`${baseCurrency.symbol} `}
                                        displayType="text"
                                        value={
                                          cuenta.amount
                                            ? Number(cuenta.amount).toFixed(2)
                                            : "0.00"
                                        }
                                      />
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Table>
                        {/*    {cuentas.map(
                          (debt, i) =>
                            debt.id === Number(id) && (
                              <Row key={i}>
                                <Col>
                                  <p className="fs--1">
                                    <span>
                                      {debt.finance != null
                                        ? debt.finance.name
                                        : debt.reserve_fund.name}
                                    </span>
                                  </p>
                                  <p className="font-weight-semi-bold">
                                    <NumberFormat
                                      prefix={`${baseCurrency.symbol} `}
                                      fixedDecimalScale
                                      decimalScale={2}
                                      displayType="text"
                                      thousandSeparator
                                      value={debt.amount}
                                    />
                                  </p>
                                </Col>
                              </Row>
                            )
                        )} */}
                        {aliquot ? (
                          <Row>
                            <Col>
                              <p className="fs--1">
                                <span>{aliquots.description}</span>
                              </p>
                              <p className="font-weight-semi-bold">
                                <NumberFormat
                                  prefix={`${baseCurrency.symbol} `}
                                  fixedDecimalScale
                                  decimalScale={2}
                                  displayType="text"
                                  thousandSeparator
                                  value={aliquots.value}
                                />
                              </p>
                            </Col>
                          </Row>
                        ) : (
                          <></>
                        )}
                        <hr />
                        <p className="mb-0 font-weight-semi-bold">
                          Monto a pagar
                        </p>
                        <Row className="align-items-center py-2">
                          <Col>
                            <NumberFormat
                              prefix={`${baseCurrency.symbol} `}
                              className="form-control"
                              onValueChange={({ value }) => {
                                setTotal(value);
                              }}
                              isAllowed={({ floatValue }) =>
                                floatValue <= amount - total_paid &&
                                floatValue >= 0
                              }
                              fixedDecimalScale
                              decimalScale={2}
                              thousandSeparator
                              defaultValue={total}
                            />
                          </Col>
                        </Row>
                        {curr?.value && curr.value !== 1 && (
                          <Row className="mt-1">
                            <Col>
                              <span className="fs--1 text-700">
                                Equivalente:{" "}
                                <NumberFormat
                                  className="text-nowrap"
                                  value={total * curr?.value}
                                  thousandSeparator
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={`${curr?.currency?.iso} `}
                                  displayType="text"
                                />
                              </span>
                            </Col>
                          </Row>
                        )}
                        <ButtonIcon
                          color="primary"
                          icon={faDollarSign}
                          onClick={() => collapseOneOpen(!collapseOne)}
                          className="btn-block"
                        >
                          Emitir pago
                        </ButtonIcon>
                      </CardBody>
                    </Card>
                  </Col>
                </>
              ) : (
                <Card className="col-12">
                  <Loader padding="py-5" />
                </Card>
              )}
            </Row>
            <Modal isOpen={collapseOne} data-testid="modal">
              <ModalHeader>Confirmación</ModalHeader>
              <ModalBody>
                <p className="mb-0 font-weight-bold fs--1">
                  ¿Está seguro de que ingresó todos los datos correctamente?
                  Esta información no puede ser cambiada posteriormente.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button disabled={isPending} onClick={() => collapseOneOpen(!collapseOne)}>
                  Cancelar
                </Button>
                <Button
                  data-testid="submit-button"
                  color="primary"
                  type="submit"
                  disabled={isPending}
                  onClick={handleSubmit(save)}
                >
                  {isPending && <Spinner size="sm" className="mr-2" />}
                  Sí, pagar
                </Button>
              </ModalFooter>
            </Modal>
          </>
        </PreloadState>
      </Card>
    </Fragment>
  );
};

export default withRedirect(CreatePropertyPayment);
